// PrintableInvoice.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import useRandomIcon from "../utils/useRandomIcon";
import useLanguage from "../utils/useLanguage";

const NoCustomerInvoicePrintTemplate = React.forwardRef(({ invoice }, ref) => {
  const { t } = useTranslation("general");
  const getRandomIcon = useRandomIcon();
  const { currentDirection } = useLanguage();

  // A helper function to render a detail row.
  const DetailRow = ({ title, value }) => (
    <div className="nci-detail">
      <span className="nci-detail-title">{t(title)}:</span>
      <span>{value}</span>
    </div>
  );

  return (
    <div ref={ref} className="nci-main-container" dir={currentDirection}>
      {/* Header for every page */}
      <div className="nci-header">
        <h2>{t("invoiceDetails")}</h2>
      </div>

      {/* Invoice Details Section */}
      <div className="nci-section">
        <div className="nci-section-header">{t("invoiceDetails")}</div>
        {/* <div className="o-row o-row--horizontal-align_space-between"> */}
        <div>
          <DetailRow title="supplier" value={invoice?.supplier?.name} />
          <DetailRow title="company" value={invoice?.subCompany?.nameInAr} />
        </div>
        <div className="">
          <DetailRow title="createdBy" value={invoice?.user?.username} />
          <DetailRow title="invoiceNumber" value={invoice?.invoiceNumber} />
        </div>
        {/* </div> */}

        <DetailRow
          title="Date"
          value={new Date(invoice?.date).toLocaleDateString()}
        />
        <DetailRow title="notes" value={invoice?.notes || t("noNotes")} />
        <DetailRow
          title="amountForSupplier"
          value={invoice?.amountForSupplier}
        />
        <DetailRow
          title="abstractAmountForCustomer"
          value={invoice?.abstractAmountForCustomer}
        />
        <DetailRow
          title="finalAmountForCustomer"
          value={invoice?.finalAmountForCustomer}
        />
      </div>

      {/* Bank Application Section */}
      <div className="nci-section">
        <div className="nci-section-header">{t("bankApplicationInfo")}</div>
        {invoice?.bank ? (
          <div className="nci-bank-info">
            <DetailRow title="bankAppCreator" value={invoice?.bankAppCreator} />
            <DetailRow
              title="bankName"
              value={invoice?.applicationBank?.name}
            />
          </div>
        ) : (
          <div className="nci-no-info">{t("noBankApps")}</div>
        )}
      </div>

      {/* Containers Section */}
      <div className="nci-section containers-section">
        <div className="nci-section-header">{t("containers")}</div>
        {invoice?.ShippedContainer?.length > 0 ? (
          <div className="nci-container-grid">
            {invoice.ShippedContainer.map((container, index) => (
              <div key={container.id} className="nci-container-card">
                <img
                  src={getRandomIcon()}
                  alt="Container"
                  className="nci-container-image"
                />
                <DetailRow
                  title="containerNumber"
                  value={container?.containerNumber}
                />
                <DetailRow
                  title="containerDescription"
                  value={container?.containerDescription || "N/A"}
                />
                <DetailRow
                  title="customerName"
                  value={container?.customer?.name}
                />
                <DetailRow
                  title="shippingDate"
                  value={
                    container?.shippingDate
                      ? new Date(container?.shippingDate).toLocaleDateString()
                      : t("noDate")
                  }
                />
                <DetailRow
                  title="arrivalDate"
                  value={
                    container?.expectedArrivalDate
                      ? new Date(
                          container?.expectedArrivalDate
                        ).toLocaleDateString()
                      : t("noDate")
                  }
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="nci-no-info">{t("noContainers")}</div>
        )}
      </div>

      {/* Footer for every page */}
      <div className="nci-footer">
        <p>{t("ehsiblySecondSlogan")}</p>
        <p>{t("alhabbarSlogan")}</p>
      </div>

      {/* Invisible page break for a large number of containers */}
      <div className="nci-page-break"></div>
    </div>
  );
});

export default NoCustomerInvoicePrintTemplate;
